import img from "../assets/bot-icon.svg";

const bot = {
	icon: img,
	messages: [],
};
const user = {
	icon: img,
	messages: [],
};

const botChats = { bot, user };
export default botChats;
